import { useMutation } from "@apollo/client";
import { PAGE, TRACK } from "@graphQl/mutations/analytics";

const getUserContext = () => {
	const locale = navigator.language || "en-US";
	const userAgent = navigator.userAgent;
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	return {
		userAgent,
		locale,
		timezone,
	};
};

export const useAnalytics = () => {
	const [trackMutation] = useMutation(TRACK);
	const track = (event, properties) => {
		const userContext = getUserContext();
		trackMutation({
			variables: {
				type: event,
				properties: JSON.stringify(properties),
				context: userContext,
			},
		});
	};

	return { track };
};

export const usePageAnalytics = () => {
	const [pageMutation] = useMutation(PAGE);
	const page = (name, properties) => {
		const userContext = getUserContext();
		pageMutation({
			variables: {
				name: name,
				properties: JSON.stringify(properties),
				context: userContext,
			},
		});
	};

	return { page };
};
